export default __webpack_public_path__ + "static/media/icon-3.be08e405.svg";